/**
 * @fileoverview Combo button with a default action and dropdown menu
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.menu.trigger.ComboTrigger');

import {DropdownTrigger, DropdownProps} from '/ui/components/dropdowntrigger/dropdowntrigger';
import {MenuAction} from '/ui/components/menu/action/menuaction';
import {Action} from '/ui/components/menu/types/action';
import {hasManaUITheme} from '/ui/design/hasManaUITheme';

import * as styles from '/ui/components/dropdowntrigger/dropdowntrigger.module.scss';

/**
 * @record
 * @extends {DropdownProps}
 */
export function ComboTriggerProps() {}
/** @type {!Action} */
ComboTriggerProps.prototype.defaultAction;
/** @type {boolean|undefined} */
ComboTriggerProps.prototype.primary;
/** @type {string|undefined} */
ComboTriggerProps.prototype.pendoId;

/**
 * @param {ComboTriggerProps} props
 * @returns {React.ReactElement}
 */
export function ComboTrigger(props) {
  const classList = ['btn-default', 'ui-menu-default-action', styles.smallViewSupport, styles.fontSizing];
  if (hasManaUITheme()) {
    classList.push(styles.neutral);
  }

  if (props.primary) {
    classList.push(styles.primary);
  }

  if (props.ghost) {
    classList.push(styles.ghost, styles.trigger, styles.triggerCombo);
  }

  // NOTE(amullings): This should use a separate implementation than MenuAction,
  // since there are many features (secondary text, nested actions, etc) that
  // don't make sense for the default action and currently result in broken
  // layouts if used. Ideally the default action would be specified in a
  // separate prop instead of bein controlled with a flag, that way we could
  // properly document the supported subset of Action fields.
  return (
    <div className="ui-menu-combotrigger">
      <MenuAction
        classList={classList}
        action={props.defaultAction}
      />
      {React.createElement(DropdownTrigger, props, props.children)}
    </div>
  );
}
